import { createContext, useContext } from 'react';

import { MessageMedium } from '../../domain';
import { ExtendedChannel, ExtendedMessageType } from '../types';

type QueryContextState = {
  channelMedia: MessageMedium[];
  channels: ExtendedChannel[];
  marketingChannels: ExtendedChannel[];
  messageTypes: ExtendedMessageType[];
  isLoading: boolean;
  isError: boolean;
};

const defaultState = {
  channelMedia: [],
  channels: [],
  marketingChannels: [],
  messageTypes: [],
  isLoading: false,
  isError: false,
};

export const QueryContext = createContext<QueryContextState>(defaultState);

export const useQueryContext = () => useContext(QueryContext);
